import styled from 'styled-components';

import { Colors } from '../../theme';
import { RegularXs } from '../../typography';

export default styled(RegularXs)`
  color: ${Colors.Destructive};
`;
